import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { Printer, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

const TARGETS = {
  club: { label: "UNGRIP Club", line1: "ENTRA NEL CLUB", line2: "chi morde prima, sa prima." },
  reviews: { label: "Recensioni Google", line1: "LASCIA IL SEGNO", line2: "ti è preso? diccelo." },
};

export default function BagQR() {
  const [params, setParams] = useSearchParams();
  const target = params.get("target") === "reviews" ? "reviews" : "club";
  const [reviewUrl, setReviewUrl] = useState("");

  useEffect(() => {
    api.get("/settings").then(({ data }) => setReviewUrl(data?.links?.google_review_url || ""));
  }, []);

  const url = target === "club"
    ? `${window.location.origin}/?utm_source=qr&utm_medium=bag&utm_campaign=club#club`
    : reviewUrl;
  const t = TARGETS[target];

  return (
    <div className="min-h-screen bg-[#0C0C0C] print:bg-white flex flex-col items-center py-8 print:py-0">
      <style>{`@page{size:A4 portrait;margin:0}@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}}`}</style>
      <div className="flex flex-wrap justify-center gap-3 mb-6 print:hidden">
        <Link to="/admin" className="inline-flex items-center gap-2 rounded-full border border-[#444] text-white font-display font-bold uppercase px-5 py-2.5" data-testid="bagqr-back">
          <ArrowLeft size={16} /> Admin
        </Link>
        {Object.entries(TARGETS).map(([k, v]) => (
          <button key={k} onClick={() => setParams({ target: k })} data-testid={`bagqr-target-${k}`}
            className={`rounded-full px-5 py-2.5 font-display font-bold uppercase ${target === k ? "bg-[#FFC20E] text-[#0C0C0C]" : "border border-[#444] text-white"}`}>
            {v.label}
          </button>
        ))}
        <button onClick={() => window.print()} disabled={!url} className="inline-flex items-center gap-2 rounded-full bg-[#FFC20E] text-[#0C0C0C] font-display font-extrabold uppercase px-5 py-2.5 disabled:opacity-50" data-testid="bagqr-print-button">
          <Printer size={16} /> Stampa
        </button>
      </div>

      <div className="bg-white w-[210mm] h-[297mm] p-[10mm] grid grid-cols-3 grid-rows-4 gap-[6mm] print:w-[210mm] print:h-[297mm]" data-testid="bagqr-sheet" data-url={url}>
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="rounded-[4mm] bg-[#FFC20E] border-[0.6mm] border-dashed border-[#0C0C0C]/40 flex flex-col items-center justify-center text-center p-[2mm]">
            <div className="bg-[#0C0C0C] rounded-[2mm] px-[3mm] py-[1mm]">
              <img src="/assets/10_logo_ungrip_header.png" alt="UNGRIP" className="h-[9mm]" />
            </div>
            <div className="bg-white p-[1.5mm] rounded-[2mm] mt-[2mm]">
              {url ? <QRCodeSVG value={url} size={120} level="M" fgColor="#0C0C0C" style={{ width: "30mm", height: "30mm" }} /> : null}
            </div>
            <p className="font-display font-black uppercase text-[5mm] leading-none text-[#0C0C0C] mt-[2mm]">{t.line1}</p>
            <p className="font-hand font-bold text-[4mm] text-[#0C0C0C] leading-none mt-[1mm]">{t.line2}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
